import { Link } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import { useLatestPosts } from '../hooks/blog';
import { getAssetUrl, Post } from '../lib/directus';

const NEWS_LIMIT = 3;

export default function RecentNews() {
  const { posts, loading, error } = useLatestPosts(NEWS_LIMIT);

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Последние новости
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Следи за событиями чемпионата
          </p>
        </div>

        {loading && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[...Array(NEWS_LIMIT)].map((_, i) => (
              <div key={i} className="card h-80 animate-pulse bg-gray-200" />
            ))}
          </div>
        )}

        {!loading && error && <p className="text-center text-gray-600">{error}</p>}

        {!loading && !error && posts.length === 0 && (
          <p className="text-center text-gray-500">
            Новостей пока нет — загляните позже.
          </p>
        )}

        {!loading && !error && posts.length > 0 && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {posts.map((post: Post) => (
                <article
                  key={post.id}
                  className="card hover:shadow-xl transition-shadow flex flex-col"
                >
                  {post.cover && (
                    <Link
                      to={`/blog/${post.slug}`}
                      className="block overflow-hidden rounded-lg mb-4"
                    >
                      <img
                        src={getAssetUrl(post.cover) ?? undefined}
                        alt={post.title}
                        loading="lazy"
                        className="w-full h-44 object-cover transition-transform duration-200 hover:scale-105"
                      />
                    </Link>
                  )}

                  <time
                    dateTime={post.publish_date}
                    className="inline-flex items-center gap-2 text-sm text-gray-500 mb-2"
                  >
                    <Calendar className="h-4 w-4 text-primary-500" />
                    {new Date(post.publish_date).toLocaleDateString('ru-RU', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                    })}
                  </time>

                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    <Link
                      to={`/blog/${post.slug}`}
                      className="hover:text-primary-600 transition-colors"
                    >
                      {post.title}
                    </Link>
                  </h3>

                  {post.excerpt && (
                    <p className="text-gray-600 line-clamp-3 mb-4">{post.excerpt}</p>
                  )}

                  <Link
                    to={`/blog/${post.slug}`}
                    className="mt-auto inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700"
                  >
                    Читать далее
                    <ArrowRight className="h-4 w-4" />
                  </Link>
                </article>
              ))}
            </div>

            <div className="text-center mt-12">
              <Link to="/blog" className="btn-secondary inline-flex items-center gap-2">
                Все новости
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </>
        )}
      </div>
    </section>
  );
}
